import React from "react";
import useStyles from './styles';

const Separator = () => {
    
    const classes = useStyles();

    return (
        <div className={classes.separator}>
            <div className={`${classes.item} ${classes.green70}`}></div>
            <div className={`${classes.item} ${classes.green60}`}></div>
            <div className={`${classes.item} ${classes.green40}`}></div>
            <div className={`${classes.item} ${classes.green30}`}></div>
            <div className={`${classes.item} ${classes.green10}`}></div>
        </div>
    );
}

export default Separator;